<ng-template #linkLiabilitiesToReo>
  <div id="reo-main">
    <form #linkLiabilityToReoForm="ngForm" novalidate class="form-horizontal" name="linkLiabilityToReoForm">
      @for (liability of liabilities; track liability.liabilityId; let i = $index) {
        <div class="col-md-12 fv-row mb-5">
          <div class="card card-flush shadow-sm">
            <div class="card-body py-2">
              <liability-reo #liabilityInfo [reos]="reos" [liability]="liability"></liability-reo>
            </div>
          </div>
        </div>
      }
    </form>
  </div>
</ng-template>

<wizard-step-template [stepMainTemplate]="linkLiabilitiesToReo" [stepComponent]="this"
  [step]="step"></wizard-step-template>
